import React from 'react';
import TextField from '@material-ui/core/TextField';
import _ from "lodash";
import {FormControl, IconButton, InputAdornment, Link} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";

const UrlTextField = ({errorMessage, ...props}) => {
    const url = !/^https?:\/\//i.test(props.value) ? `https://${props.value}` : props.value;
    return (
        <FormControl fullWidth>
            <TextField
                {...props}
                InputProps={{
                    endAdornment: <InputAdornment position="end">
                        <IconButton
                            aria-label="go to site"
                            edge="end"
                        >
                            {
                                !_.isEmpty(props.value) && !props.error ? <Link href={url} target={"_blank"}>
                                    <LinkIcon />
                                </Link> : <LinkIcon />
                            }
                        </IconButton>
                    </InputAdornment>
                }}
            />
            <span>{errorMessage}</span>
        </FormControl>
    );
}

export default UrlTextField;